import React from 'react'
import Navigation from './Navigation'
import HeroSection from './HeroSection'
import FeaturedProducts from './FeaturedProduct'
import FeaturesSection from './FeaturesSection'
import Footer from './Footer'

function Homes() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <HeroSection />
      <FeaturedProducts />
      <FeaturesSection />
      <Footer />
    </div>
  )
}

export default Homes